module.exports = __webpack_public_path__ + "static/Hindu Women Gender Issues & Law-831805af1f1e81914666c2d2106c3b68.jpg";